import React, { useState, useEffect } from 'react';
import { useAuthStore } from '../../store/authStore';
import api from '../../api/client';
import AdminTile from '../../components/admin/AdminTile';
import {
  Database, GitBranch, Users, Palette, Shield, UserPlus, FileText, BookOpen,
  Mail, Brain, DollarSign, LayoutGrid, Phone, ScanLine, FileOutput,
  Link2, PenTool, Receipt, BarChart3, UserCheck, ShoppingBag,
  Trash2, FileSearch, CalendarClock, HelpCircle, GitMerge, ClipboardList, BarChart2
} from 'lucide-react';

const ICON_MAP = {
  Database, GitBranch, Users, Palette, Shield, UserPlus, FileText, BookOpen,
  Mail, Brain, DollarSign, LayoutGrid, Phone, ScanLine, FileOutput,
  Link2, PenTool, Receipt, BarChart3, UserCheck, ShoppingBag,
  Trash2, FileSearch, CalendarClock, GitMerge, ClipboardList, BarChart2,
};

export default function AdminDashboard() {
  const { tenant } = useAuthStore();
  const [features, setFeatures] = useState([]);
  const [loadingFeatures, setLoadingFeatures] = useState(true);
  const [plan, setPlan] = useState(null);

  useEffect(() => {
    api.get('/features').then(r => {
      setFeatures(r.data || []);
      setLoadingFeatures(false);
    }).catch(() => setLoadingFeatures(false));
    api.get('/services/plan').then(r => setPlan(r.data?.plan || null)).catch(() => {});
  }, []);

  const currentPlanName = plan?.name || 'free';

  const handleUpgraded = () => {
    api.get('/features').then(r => setFeatures(r.data || [])).catch(() => {});
    api.get('/services/plan').then(r => setPlan(r.data?.plan || null)).catch(() => {});
  };

  return (
    <div className="max-w-5xl mx-auto">
      <div className="mb-8">
        <h1 className="text-2xl font-bold text-gray-900">Admin Panel</h1>
        <p className="text-gray-500 mt-1">Configure {tenant?.name}</p>
      </div>

      {loadingFeatures ? (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {[...Array(9)].map((_, i) => (
            <div key={i} className="h-32 bg-gray-100 rounded-xl animate-pulse" />
          ))}
        </div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {features.map(feature => (
            <AdminTile
              key={feature.slug}
              title={feature.name}
              description={feature.description}
              icon={ICON_MAP[feature.icon] || HelpCircle}
              iconColor={feature.icon_color}
              iconBg={feature.icon_bg}
              to={feature.route}
              locked={feature.locked}
              lockedPlan={feature.min_plan}
              comingSoon={feature.status === 'coming_soon'}
              currentPlan={currentPlanName}
              onUpgraded={handleUpgraded}
            />
          ))}
        </div>
      )}
    </div>
  );
}
